/** @jsxImportSource @emotion/react */
'use memo'

import { FileSearchOutlined } from '@ant-design/icons'
import type { OrgRegistrationTab } from '@sportninja/common/features/organization/registration/types'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import EmptyState from 'src/components/ts-components/EmptyState'

interface Props {
  status: OrgRegistrationTab
}

const EMPTY_TITLES: Record<OrgRegistrationTab, string> = {
  open: 'No Open Registrations',
  upcoming: 'No Upcoming Registrations',
  all: 'No Registrations',
}

/** Nothing matches the tab and filters — the same message in either view. */
const OrgRegistrationEmptyState = ({ status }: Props) => {
  'use memo'

  return (
    <EmptyState
      icon={<FileSearchOutlined />}
      title={capitalizeWords(EMPTY_TITLES[status])}
      subtitle='Try a different search or filter, or check the other tabs.'
    />
  )
}

export default OrgRegistrationEmptyState
